import { styled } from '@/src/stitches.config'

const Wrapper = styled('div', {
    display: 'flex',
    ai: 'center',
    gap: '10%',
    my: 20,
    '& p': {
        mb: 0,
        textTransform: 'uppercase',
        textWrap: 'nowrap',
    },
})
const Line = styled('div', {
    width: '100%',
    height: 0,
    border: '1px solid $light',
})

interface ISeparatorProps {
    text?: string
    padding?: string | number
}

const OptionSeparator = ({ text = 'or', padding }: ISeparatorProps) => {
    return (
        <Wrapper id={'option-separator'} style={{ padding: padding }}>
            <Line />
            <p style={{ margin: 0 }}>{text}</p>
            <Line />
        </Wrapper>
    )
}

export default OptionSeparator
